import {Link, useNavigate, useParams} from 'react-router-dom';

import {QuestionMatchingEvaluation} from '~/features/AiSupport/QuestionMatchingEvaluation';

export const QuestionMatchingEvaluationScene = () => {
  const {questionSampleSetId} = useParams();
  const navigate = useNavigate();
  return (
    <div className="bg-background min-h-screen">
      <div className="text-sm breadcrumbs p-4">
        <ul>
          <li>
            <Link to="/">Home</Link>
          </li>
          <li>
            <Link to="/ai-support/question-sample-sets">
              Question Sample Sets
            </Link>
          </li>
          <li>
            <Link
              to={`/ai-support/question-sample-sets/${questionSampleSetId}`}>
              {questionSampleSetId}
            </Link>
          </li>
          <li>Evaluation</li>
        </ul>
      </div>
      <QuestionMatchingEvaluation
        questionSampleSetId={questionSampleSetId ?? ''}
        onNavToQuestionSampleSet={(id: string) => {
          navigate(`/ai-support/question-sample-sets/${id}`);
        }}
      />
    </div>
  );
};
